import { render, staticRenderFns } from "./StepRequisites.vue?vue&type=template&id=05333bd0&"
import script from "./StepRequisites.vue?vue&type=script&lang=js&"
export * from "./StepRequisites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports